import { createIcon } from "@chakra-ui/react";

export const Distracted = createIcon({
  displayName: "Distracted",
  viewBox: "0 0 32 32",
  path: [
    <path
      d="M3.5 16a12.5 12.5 0 1 0 24.999 0A12.5 12.5 0 0 0 3.5 16zm7.5 5c0-.23.188-.417.417-.417h9.166c.23 0 .417.188.417.417 0 .23-.188.417-.417.417h-9.166A.418.418 0 0 1 11 21z"
      fill="#fff"
    />,
    <path
      d="M16.001 3.5a12.5 12.5 0 1 1 0 24.999 12.5 12.5 0 0 1 0-25zm0 25.833a13.333 13.333 0 1 0 0-26.667 13.333 13.333 0 0 0 0 26.667zm-.646-18.167a.833.833 0 1 0-1.666 0 .833.833 0 0 0 1.666 0zm7.5.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666zm-11.437 8.584a.418.418 0 0 0-.417.416c0 .23.188.417.417.417h9.167c.229 0 .416-.188.416-.417a.418.418 0 0 0-.416-.416h-9.167z"
      fill="currentColor"
    />
  ],
  defaultProps: {
    "aria-label": "Neutral face looking away emoji"
  }
});

export default Distracted;
